import {useActions, useGetters, useMutators, useState} from './_default';
import axios from "axios";
export default {
    namespaced: true,
    state: {
        ...useState(),
        unreadCount: 0,
    },
    getters: {
        ...useGetters(),
        unreadCount: state => state.unreadCount,
    },
    mutations: {
        ...useMutators(),
    },
    actions: {
        ...useActions(),
        getUnreadCount({ state }) {
            return new Promise((resolve, reject) => {
                axios.get('/chat/unread/count').then((response) => {
                    state.unreadCount = response.data.count;
                    resolve(state.unreadCount);
                });
            });
        },

        getChat({ state }, id) {
            return new Promise((resolve, reject) => {
                axios.get(`/chat/${id}`).then((response) => {
                    resolve(response);
                });
            })
        },

        initChat({ state, rootState }, id) {
            return new Promise((resolve, reject) => {
                axios.get(`/chat/init/${id}`).then((response) => {
                    resolve(response);
                });
            })
        }
    },
}
